import usePageSeo from '../../hooks/usePageSeo.js';
import useSeo from '../../hooks/useSeo.js';

export default function Seo({ seo, pagePath, fallback = {} }) {
  const fetched = usePageSeo(pagePath); // no-op when pagePath is falsy
  const resolved = seo || fetched || null;
  const r = resolved || {};

  useSeo({
    title: r.metaTitle || fallback.title || undefined,
    description: r.metaDescription || fallback.description || undefined,
    canonical: r.canonicalUrl || fallback.canonical || undefined,
    ogTitle: r.ogTitle || fallback.ogTitle || undefined,
    ogDescription: r.ogDescription || fallback.ogDescription || undefined,
    ogImage: r.ogImage || fallback.ogImage || undefined,
    ogImageAlt: fallback.ogImageAlt || undefined,
    ogType: fallback.ogType || 'website',
    noindex: r.noindex ?? fallback.noindex ?? false,
    nofollow: r.nofollow ?? fallback.nofollow ?? false,
    robots: r.robots || undefined,
    // A resolved DB title is verbatim; a page may also opt its fallback out of
    // the "Label | Site" suffix.
    exactTitle: r.metaTitle ? true : !!fallback.exactTitle,
  });

  return null;
}
